import { combineReducers, configureStore } from '@reduxjs/toolkit';
import accessSlice from './access.store';
import authSlice from './auth.store';
import globalMiddelWare from './middleware';
import modules, {
  dashboardModule,
  subscrtiptionsModule,
  usersModule,
  librariesModule,
  settingsModule,
  organizationModule,
  logsModule,
  Module,
} from '../modules';
import membersSlice from './members.store';
import { createReduxEnhancer } from '@sentry/react';

const rootReducer = combineReducers({
  global: authSlice.reducer,
  accesss: accessSlice.reducer,
  members: membersSlice.reducer,
  ...dashboardModule.reducers,
  ...usersModule.reducers,
  ...logsModule.reducers,
  ...subscrtiptionsModule.reducers,
  ...librariesModule.reducers,
  ...settingsModule.reducers,
  ...organizationModule.reducers,
});

export type RootState = ReturnType<typeof rootReducer>;

const sentryReduxEnhancer = createReduxEnhancer({});

const store = configureStore({
  reducer: rootReducer,
  enhancers: [sentryReduxEnhancer],
  middleware: (getDefaultMiddleware) => {
    let middlewares = [globalMiddelWare.middleware];
    Object.values(modules).forEach((module: Module) => {
      if (module.middleware) {
        middlewares = [
          ...middlewares,
          ...(Array.isArray(module.middleware) ? module.middleware : [module.middleware]).map((m) => m.middleware),
        ];
      }
    });
    const middlewareResult = getDefaultMiddleware().prepend(...middlewares);

    return middlewareResult;
  },
});

export default store;
